import {MutableRefObject, useRef} from 'react';

import {EqualityFn} from 'react-redux';

import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {HostApplicationStoreType} from 'hostApplicationStoreType';

/**
 * useSelector but with ref, in order to use it in hooks deps, without their recreation-recall
 */
export const useHostSelectorRef: <Selected = unknown>(
    selector: (state: HostApplicationStoreType) => Selected,
    equalityFn?: EqualityFn<Selected> | undefined,
) => MutableRefObject<Selected> = (selector, equalityFn) => {
    const selectedState = useHostSelector(selector, equalityFn);
    const selectedStateRef = useRef(selectedState);
    selectedStateRef.current = selectedState;

    return selectedStateRef;
};
